import VerofreshRecord from './VerofreshRecord'

class RoutePlanLocationRecord extends VerofreshRecord {
}

const relations = {
  belongsTo: {
    Location: {
      foreignKey: 'location_id',
      localField: 'location'
    },
    RoutePlan: {
      foreignKey: 'route_plan_id',
      localField: 'route_plan'
    }
  }
}

export default RoutePlanLocationRecord

export { relations }
